/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import get from 'lodash/get';
import {
    asyncDefaults,
    makeAsyncReducer,
    mergeReducers,
} from 'ui-permit/shared-components/utils/async';
import { PREFIX } from '../constants';
import * as ACTIONS from '../constants/actions';

const fetchSeasons = makeAsyncReducer(ACTIONS.FETCH_SEASONS);

const seasons = mergeReducers(asyncDefaults([]), PREFIX, fetchSeasons);

export default seasons;

export const selectors = {
    getSeasons: (state) => {
        const seasonsData = get(state, 'huntingpermit.seasons.data', null);
        if (seasonsData) return seasonsData;
        return [];
    },
};
